import { useRequestEvent } from "#imports";
import { getRequestExperiments } from "../server/getRequestExperiments.js";
import { getDefaultExperiments } from "../utils.js";
export function useExperiments() {
  const defaultExperiments = getDefaultExperiments();
  if (import.meta.server) {
    const event = useRequestEvent();
    if (event) return getRequestExperiments(event);
    return { ...defaultExperiments };
  }
  return {
    ...defaultExperiments,
    // By using underscore dangles, we follow the same structure as Nuxt.
    // eslint-disable-next-line no-underscore-dangle
    ...window.__EXPERIMENTS__
  };
}
